export default __webpack_public_path__ + "images/87f860dadfb7f3f52264c2417045e115.svg";